import { render, staticRenderFns } from "./ComplainListTable.vue?vue&type=template&id=a3a269be&scoped=true&"
import script from "./ComplainListTable.vue?vue&type=script&lang=js&"
export * from "./ComplainListTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a3a269be",
  null
  
)

export default component.exports